const superSupplier = {
  activeSupplier: {},
}

const SuperSupplierReducer = function (state = superSupplier, action) {
  switch (action.type) {
    case 'SET_ACTIVE_SUPPLIER': {
      return {
        ...state,
        activeSupplier: action.value,
      }
    }
    case 'RESET_ACTIVE_SUPPLIER': {
      return {
        ...state,
        activeSupplier: {},
      }
    }
    default: {
      return state
    }
  }
}

export default SuperSupplierReducer
